import React, { useRef } from 'react';
import { Link, Project } from '../../StateContext';
import PrintIcon from '@mui/icons-material/Print';

import HourOverviewPage from './HourOverviewPage';

interface IProps {
    link?: Link[];
    project?: Project;
}

const PrintablePage = (props: IProps) => {
    const contentRef = useRef<HTMLDivElement>(null);

    const openInNewTab = () => {
        if (!contentRef.current) return;

        const printWindow = window.open('', '_blank');
        if (!printWindow) return;

        const htmlContent = contentRef.current.innerHTML;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>${props.project?.name || 'Hour Overview'}</title>
                <style>
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    body {
                        background: #FFFFFF;
                        color: #000000;
                        font-family: Arial, sans-serif;
                        padding: 10mm;
                    }
                    .print-page {
                        width: 100%;
                        background: #FFFFFF;
                        color: #000000;
                        display: flex;
                        flex-direction: column;
                    }
                    .print-header {
                        text-align: center;
                        margin-bottom: 6px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 4px;
                    }
                    .print-title {
                        font-size: 14px;
                        font-weight: bold;
                        margin: 0 0 2px 0;
                        color: #000;
                    }
                    .print-project-code {
                        font-size: 9px;
                        color: #666;
                    }
                    .print-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 6px;
                        table-layout: fixed;
                    }
                    .print-th {
                        background-color: #f0f0f0;
                        border: 1px solid #ddd;
                        padding: 2px 1px;
                        text-align: center;
                        font-weight: bold;
                        font-size: 8px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .print-td {
                        border: 1px solid #ddd;
                        padding: 2px 1px;
                        text-align: center;
                        font-size: 8px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .print-week-col {
                        background-color: #f9f9f9;
                        font-weight: bold;
                        width: 35px;
                    }
                    .print-total-col {
                        background-color: #e0e0e0;
                        font-weight: bold;
                        width: 45px;
                    }
                    .print-hours-cell { width: auto; }
                    .print-total-cell {
                        background-color: #f5f5f5;
                        font-weight: bold;
                    }
                    .print-totals-row {
                        background-color: #f0f0f0;
                        font-weight: bold;
                    }
                    .print-hours-total {
                        background-color: #f0f0f0;
                        font-weight: bold;
                        font-size: 9px;
                    }
                    .print-grand-total {
                        background-color: #e0e0e0;
                        font-weight: bold;
                        font-size: 9px;
                    }
                    .print-summary {
                        border: 1px solid #ddd;
                        padding: 6px 8px;
                        margin-top: 6px;
                        float: right;
                        min-width: 180px;
                        max-width: 200px;
                    }
                    .print-summary-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 2px 0;
                        font-size: 9px;
                    }
                    .print-summary-label { font-weight: normal; }
                    .print-summary-value {
                        font-weight: bold;
                        text-align: right;
                        min-width: 45px;
                    }
                    .print-summary-result {
                        border-top: 1px solid #ddd;
                        margin-top: 3px;
                        padding-top: 3px;
                        font-size: 10px;
                        font-weight: bold;
                    }
                    .positive { color: #22c55e; }
                    .negative { color: #ef4444; }
                    .print-notes {
                        clear: both;
                        margin-top: 10px;
                        border: 1px solid #ddd;
                        padding: 6px 8px;
                    }
                    .print-notes-label {
                        font-weight: bold;
                        font-size: 9px;
                        margin-bottom: 6px;
                    }
                    .print-notes-entry {
                        margin-bottom: 6px;
                        padding-bottom: 6px;
                        border-bottom: 1px dashed #eee;
                    }
                    .print-notes-entry:last-child { border-bottom: none; margin-bottom: 0; }
                    .print-notes-date {
                        font-size: 8px;
                        color: #888;
                        display: block;
                        margin-bottom: 2px;
                    }
                    .print-notes-content {
                        font-size: 9px;
                        white-space: pre-wrap;
                        word-break: break-word;
                    }
                    @media print {
                        body { padding: 0; }
                        @page { margin: 10mm; size: A4 landscape; }
                    }
                </style>
            </head>
            <body>
                ${htmlContent}
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <React.Fragment>
            <PrintIcon onClick={openInNewTab} style={{ cursor: 'pointer' }}></PrintIcon>

            {/* Hidden render target to capture translated content */}
            <div ref={contentRef} style={{ position: 'fixed', left: '-9999px', top: 0 }}>
                <HourOverviewPage
                    link={props.link}
                    project={props.project}
                />
            </div>
        </React.Fragment>
    );
};

export default PrintablePage;
